export enum ConsolGridOrderBy {
  DateEntered = 0,
  MasterBillNumber = 1,
  HouseBillNumber = 2,
  CustomerRefNumber = 3,
  ContainerNumber = 4,
  ETD = 5,
  ETA = 6,
  ConsigneeName = 7,
  ShipmentCode = 8,
  Container = 9,
  OrderRefNumber = 10,
  ATD = 11,
  ATA = 12,
  ActualDelivery = 13
}
